import { FC, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

import { BottomSheet } from '@beeline/design-system-react/extracted-styles';
import { BottomSheetActionsType } from '@beeline/design-system-react/types/components/BottomSheet/BottomSheet.types';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { useHost } from 'src/providers/HostProvider';
import { getAdminState } from 'src/store/admin/selectors';
import { adminActions } from 'src/store/admin/slice';
import { saveEmployeePermissions } from 'src/store/permissions/services';
import { permissionsActions } from 'src/store/permissions/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { AdministratorUserPermissionsFields } from './AdministratorUserPermissionsFields';
import classes from './PermissionsBottomSheet.module.scss';

const Fields: FC = () => {
  const { permissionsAreOpened } = useSelector(getAdminState);

  const dispatch = useAppDispatch();

  const close = useCallback(() => {
    dispatch(adminActions.closePermissions());
    dispatch(permissionsActions.setEmployee(null));
  }, [dispatch]);

  const save = useCallback(async () => {
    await dispatch(saveEmployeePermissions());
    close();
  }, [close, dispatch]);

  const actions = useMemo((): BottomSheetActionsType | undefined => {
    return [
      {
        label: 'Сохранить',
        variant: 'contained',
        onClick: save,
      },
    ];
  }, [save]);

  const handleSetOpen = useCallback(
    (value: boolean) => {
      dispatch(adminActions.setPermissionsAreOpened(value));
      dispatch(permissionsActions.setEmployee(null));
    },
    [dispatch],
  );

  return (
    <BottomSheet
      isOpen={permissionsAreOpened}
      handleSetOpen={handleSetOpen}
      swiper
      modal={false}
      snapPoints={[1]}
      className={classes.settings}
      initialSnapPoint={0}
      header={{
        icon: Icons.User,
        title: 'Настройки прав',
        closeButton: true,
      }}
      actions={actions}
    >
      <div className={classes.container}>
        <AdministratorUserPermissionsFields />
      </div>
    </BottomSheet>
  );
};

export const PermissionsBottomSheet: FC = () => {
  const { host } = useHost();

  if (!host) return null;

  return createPortal(<Fields />, host);
};
